module.exports = "data:text/markdown;base64,IyMjIExpc3QgQ29tcGxldGVkCgpUaGUgcGVyY2VudGFnZSBvZiB0aGUgcHJvc3BlY3QgbGlzdCB0aGF0IGhhcyBiZWVuIHJlc29sdmVkLgo="